export const versionUpdate = {
  title: 'A new version is available',
  description: 'Reload the page to get the latest updates.',
  reload: 'Reload',
  dismiss: 'Dismiss',
} as const
